import { render } from "./ComponentFormPeriferico.vue?vue&type=template&id=77c68fb0"
import script from "./ComponentFormPeriferico.vue?vue&type=script&lang=js"
export * from "./ComponentFormPeriferico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__